jQuery(function($){
    let current_page = 1

	$('#btn_load_more').click( function(e) {
        e.preventDefault()
        current_page++

        let button = $(this) 
        let buttonWrapper = $('.blog-more')       
		let data = {
			'action': 'loadmore',
			'page' : current_page
		}

		
        $.ajax({
            url : mcData.ajaxurl,
            data: data,
            dataType: 'json',
            type:'POST',
            beforeSend: function(xhr) {
                button.text('Loading...')
            },
            success: function(response) {
                if (response) { 
                    button.text( 'Discover More' )
                    let html = response.html
                    let max_pages = response.max
                    console.log(current_page)
                    console.log(max_pages)

                    buttonWrapper.append(html)
                     

                    if (current_page >= max_pages) {
                        button.text( 'There is no more posts...' ).attr('disabled', true)
                    }
                                       
                } else {
                    // button.text( 'There is no more posts...' ).attr('disabled', true)
                }
            }
        })        
	})
})